import styled from '@emotion/styled';
import { Magnetic as Mi } from '@mitchell/react.component.ux';
export const StyledOverlayDiv = styled('div') `
	background-color: ${Mi.colorBlack};
	z-index: 1000;
	opacity: 0.7;
	position: fixed;
	height: 100%;
	width: 100%;
`;
export const StyledSpinnerDiv = styled('div') `
	position: fixed;
	background-color: ${Mi.colorWhite};
	opacity: 0.7;
	left: calc(50% - 30px);
	height: 70px;
	width: 70px;
	border-radius: 50%;
	top: calc(50% - 30px);
`;
//# sourceMappingURL=IntelligentPhotoCaptureEstimatorLoaderComponent.style.js.map